import { render, staticRenderFns } from "./PendingRequestsOverview.vue?vue&type=template&id=ee215882&scoped=true&"
import script from "./PendingRequestsOverview.vue?vue&type=script&lang=js&"
export * from "./PendingRequestsOverview.vue?vue&type=script&lang=js&"
import style0 from "./PendingRequestsOverview.vue?vue&type=style&index=0&id=ee215882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee215882",
  null
  
)

export default component.exports